import { L10n } from "./l10n";

export interface TakeAwayArticlesProps {
  takeAwayArticles: Article[];
  currencyInformation: CurrencyInformation;
  l10n: L10n;
  location?: string;
  defaultConfigId?: string;
  customConfigId?: string | null;
}

export interface RecommendationArticlesProps {
  recommendations: Article[];
  currencyInformation: CurrencyInformation;
  l10n: L10n;
  location: string;
  defaultConfigId: string;
  useDefaultId: boolean;
  customConfigId: string | null;
}

export interface Article {
  masterArticleNo: number;
  mainArticleImage: string;
  availableColors: number;
  availableModels: number;
  salesDesignation: string;
  salesArticleNo: string;
  colorCode: number;
  sizeCode: number;
  categoryLink: string;
  slot: number;
  packagingInformation: PackagingInformation;
  categoryName: string;
  priceInformation: PriceInformation;
  salesInformation: SalesInformation;
  recommendationType: RecommendationType;
  modelVersion: string;
}

export interface PriceInformation {
  minimalPrice: MinimalPrice;
  comparisonPrice?: ComparisonPrice;
  discountPrice?: DiscountPrice;
  priceType: PriceType;
}

export interface SalesInformation {
  salesArticleType: SalesArticleType;
  flagAdvertisedAsCostFreeInSet: boolean;
  hasRecommendedRetailPrice: boolean;
  isNew: boolean;
  isSale: boolean;
}

export interface CurrencyInformation {
  symbol: string;
  prependCurrencySymbol: boolean;
}

export interface MinimalPrice {
  price: Price;
  quantity: number;
}

export interface ComparisonPrice {
  price: Price;
  quantity: number;
  unit: string;
}

export interface DiscountPrice {
  price: Price;
  priceDeduction: number;
}

export interface Price {
  grossValue: string;
  netValue: string;
}

export interface PackagingInformation {
  quantityUnitPlural: string;
  quantityUnitSingular: string;
}

export enum PriceType {
  Only = "only",
  From = "from"
}

export enum SalesArticleType {
  NormalArticle = "normalArticle",
  VoucherArticle = "voucherArticle",
  ArticleSet = "articleSet"
}

export enum RecommendationType {
  TopSeller = "topseller",
  Manual = "manual",
  Model = "model"
}
